import companiesQuery from "../firestore/Companies.query";
import { AttendingGroups } from "../model/Users";
import userQuery from "../firestore/User.query";
import { createEvenReplyButtons } from "../utility/CreateEventReplyButtonUtility";
import { Company } from "../model/Companies";
import { Groups } from "../model/Groups";
import { ReplyButton } from "../model/ReplyButton";
import { OnlineUrls } from "../model/OnlineUrls";
import messagesQuery from "../firestore/Messages.query";
import { Token } from "../model/Message";

// MessageList・MessageInfo・Schedule共通クラス
export class MessagingIntController {
  main = async (
    tenantId: string,
    messageId: string,
    setCompany: React.Dispatch<React.SetStateAction<Company | undefined>>,
    setGroupList: React.Dispatch<React.SetStateAction<Groups[]>>,
    setFilteredGroupList: React.Dispatch<React.SetStateAction<Groups[]>> | undefined,
    setReplyButtonList: React.Dispatch<React.SetStateAction<ReplyButton[]>> | undefined,
    setDefaultReplyButtonList: React.Dispatch<React.SetStateAction<ReplyButton[]>> | undefined,
    setAttendingGroupList: React.Dispatch<React.SetStateAction<AttendingGroups[]>> | undefined,
    setTokenList: React.Dispatch<React.SetStateAction<Token[]>> | undefined,
    setEventReplyButtonList: React.Dispatch<React.SetStateAction<ReplyButton[]>> | undefined,
    setOnlineUrlList: React.Dispatch<React.SetStateAction<OnlineUrls[]>>,
    setGetDataFinishFlg?:React.Dispatch<React.SetStateAction<boolean>>,
  ) => {
    // 初期データ取得 MessageList・MessageInfo・Scheduleほぼ共通
    // 団体を取得
    const company = await companiesQuery.getCompany(tenantId);
    setCompany(company);
    // 団体グループ取得
    const groupList = (await companiesQuery.getGroups(company.id)).filter((group) => group.deleteFlg === false);

    if (setReplyButtonList !== undefined || setDefaultReplyButtonList !== undefined) {
      // 返信ボタン一覧取得
      const replyButtons = await companiesQuery.getReplyButtons(tenantId);
      replyButtons.unshift({
        id: "undefined",
        tenantId: company.id,
        name: "",
        buttonNumber: 0,
        buttonName: [""],
        buttonColor: [],
        type: "",
        createUser: "",
        createAt: new Date()
      });
      if (setReplyButtonList !== undefined) {
        setReplyButtonList(replyButtons);
      }
      if (setDefaultReplyButtonList !== undefined) {
        setDefaultReplyButtonList(replyButtons);
      }
    }

    if(setAttendingGroupList !== undefined){
      // 利用者が所属するグループを取得
      const attendingGroups = await userQuery.getAttendingGroups(company.id) as AttendingGroups[];
      setAttendingGroupList(attendingGroups);
      // 団体グループの利用者数を算出
      const countById = new Map<string, number>();

      for (const a of attendingGroups) {
        const id = String(a.id);
        countById.set(id, (countById.get(id) ?? 0) + 1);
      }

      for (const g of groupList) {
        g.userCount = countById.get(String(g.id)) ?? 0;
      }
    }
    setGroupList(groupList);
    if(setFilteredGroupList !== undefined){
      setFilteredGroupList(groupList);
    }

    if (setTokenList !== undefined) {
      // お知らせToken取得
      const tokenList = await messagesQuery.getToken(messageId);
      setTokenList(tokenList);
    }

    if (setEventReplyButtonList !== undefined) {
      // イベント用返信ボタン作成
      const eventReplyButtons = createEvenReplyButtons();
      console.log(`-- eventReplyButtons`);
      eventReplyButtons.forEach((button) => {
        console.log(` -- ${button.buttonNumber} / ${button.buttonName}`);
        button.tenantId = tenantId;
      });
      setEventReplyButtonList(eventReplyButtons);
    }

    // ZoomURL一覧取得
    const onlineUrls = await companiesQuery.getOnlineUrls(tenantId);
    onlineUrls.unshift({
      id: "none",
      onlineType: "",
      name: "設定なし",
      url: "none",
      type: "",
      createUser: "",
      createAt: new Date()
    },
    {
      id: "input",
      onlineType: "",
      name: "直接URLを入力",
      url: "",
      type: "",
      createUser: "",
      createAt: new Date()
    });
    setOnlineUrlList(onlineUrls);
    
    // 全ての処理が完了したかを判定する
    if(setGetDataFinishFlg){
      setGetDataFinishFlg(true);
    };
  }
}